import { A11y, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ProductImage } from './ProductImage';
import { ProductVideo } from './ProductVideo';

export function ProductMediaSlider({
  memoizedProductMedia,
  onSwiper,
  onSlideChange,
  navigation = false,
}) {
  return (
    <Swiper
      modules={[A11y, Pagination]}
      slidesPerView={1}
      grabCursor
      centeredSlides
      loop
      lazy={{
        loadPrevNext: true,
      }}
      navigation={navigation}
      onSwiper={onSwiper}
      onSlideChange={(s) => onSlideChange?.(s.realIndex)}
    >
      {memoizedProductMedia?.map((media, index) => {
        const { mediaContentType, image, product, sources, preview } = media;

        return (
          <SwiperSlide key={index}>
            <div>
              {mediaContentType === 'VIDEO' ? (
                <ProductVideo media={media} controls={true} />
              ) : (
                <ProductImage media={media} priority={index === 0} />
              )}
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}
